import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput
} from '@mui/material';
import {
  IErrorMessage,
  useErrorMessage
} from '@shared/hooks/use-error-message';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@shared/components/info-tooltip/info-tooltip';
import { CategoriesProps } from '@modules/entertainment/models/entertainment.models';
import {
  trimFormValues,
  validateNotOnlySpaces
} from '@shared/utils/trim-form-values-utils';

const CategoryDialog: React.FC<CategoriesProps> = ({
  selectedValue,
  loading,
  handleSave
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm({ mode: 'onChange' });

  const getErrorMessage = useErrorMessage();

  const { t } = useTranslation();

  const errorMessages: IErrorMessage = {
    title: {
      required: 'validation_name_required',
      notOnlySpaces: 'validation_notOnly_spaces_required'
    },
    descriptio: {
      required: 'validation_description_required',
      notOnlySpaces: 'validation_notOnly_spaces_required'
    }
  };

  const handleSaveCategory = async (data: any) => {
    const trimmedData = trimFormValues(data);
    handleSave(trimmedData);
  };

  useEffect(() => {
    if (selectedValue) {
      setValue('title', selectedValue?.name || '');
      setValue('description', selectedValue?.description || '');
    }
  }, [selectedValue, setValue]);

  return (
    <div>
      <div>
        <form className="flex flex-col gap-1">
          <FormControl error={!!errors.name}>
            <FormLabel className="flex">
              <span className="reuqired-symbole">*</span>
              {t('label_name')}
              <InfoTooltip text="tooltip_info_genre_name" />
            </FormLabel>
            <OutlinedInput
              {...register('title', {
                required: true,
                validate: {
                  notOnlySpaces: validateNotOnlySpaces
                }
              })}
              error={!!errors.name}
            />
            <FormHelperText>
              {errors?.name &&
                getErrorMessage({
                  errors,
                  fieldName: 'title',
                  errorMessages
                })}
            </FormHelperText>
          </FormControl>

          <FormControl error={!!errors.name}>
            <FormLabel className="flex">
              <span className="reuqired-symbole">*</span>
              {t('label_description')}
              <InfoTooltip text="tooltip_info_category_description" />
            </FormLabel>
            <OutlinedInput
              {...register('description', {
                required: true,
                validate: {
                  notOnlySpaces: validateNotOnlySpaces
                }
              })}
              error={!!errors.name}
            />
            <FormHelperText>
              {errors?.name &&
                getErrorMessage({
                  errors,
                  fieldName: 'description',
                  errorMessages
                })}
            </FormHelperText>
          </FormControl>
          <div className="flex justify-end items-center gap-6">
            <Button
              loading={loading}
              disabled={!isValid}
              onClick={handleSubmit(handleSaveCategory)}
              variant="contained"
            >
              {t('save')}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryDialog;
